// extracted by mini-css-extract-plugin
module.exports = {"errorStateRoot":"rFupRovS","showBorder":"HDVzcXqB","emailLink":"XRL9HWtD","errorSubtitle":"v47JYHh_","styledErrorMessage":"E4WlrxSK"};